import { supabase } from '../supabaseClient';

export async function getActiveDeals() {
  const { data, error } = await supabase
    .from('deals')
    .select('*')
    .eq('status', 'active')
    .or(`expires_at.is.null,expires_at.gte.${new Date().toISOString()}`)
    .order('featured', { ascending: false })
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
}

export const EVENT_TYPES = ['Festival', 'Music', 'Film', 'Arts & culture', 'Sports', 'Literature', 'Food', 'Community'];

export async function getUpcomingKeralaEvents() {
  const { data, error } = await supabase
    .from('deals')
    .select('*')
    .eq('status', 'active')
    .eq('category', 'Events')
    .eq('region', 'Kerala')
    .or(`expires_at.is.null,expires_at.gte.${new Date().toISOString()}`)
    .order('starts_at', { ascending: true, nullsFirst: false });

  if (error) throw error;
  return data || [];
}

export async function getAdminListings() {
  const { data, error } = await supabase
    .from('deals')
    .select('*')
    .order('starts_at', { ascending: true, nullsFirst: false })
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
}

export async function saveListing(listing) {
  const payload = {
    region: listing.region || 'Kerala',
    city: (listing.city || '').trim(),
    category: listing.category,
    event_type: listing.category === 'Events' ? listing.event_type || null : null,
    merchant: (listing.merchant || '').trim(),
    title: (listing.title || '').trim(),
    description: (listing.description || '').trim(),
    neighbourhood: (listing.neighbourhood || '').trim() || null,
    promo_code: (listing.promo_code || '').trim() || null,
    deal_url: (listing.deal_url || '').trim() || null,
    website_url: (listing.website_url || '').trim() || null,
    image_url: (listing.image_url || '').trim() || null,
    terms: (listing.terms || '').trim() || null,
    starts_at: listing.starts_at || null,
    expires_at: listing.expires_at || null,
    featured: listing.featured,
    status: listing.status,
  };
  const query = listing.id
    ? supabase.from('deals').update(payload).eq('id', listing.id)
    : supabase.from('deals').insert(payload);
  const { data, error } = await query.select().single();
  if (error) throw error;
  return data;
}

export async function deleteListing(id) {
  const { error } = await supabase.from('deals').delete().eq('id', id);
  if (error) throw error;
}

export const emptyListing = {
  region: 'Kerala', city: 'Kochi', category: 'Events', event_type: 'Festival', merchant: '', title: '', description: '',
  neighbourhood: '', promo_code: '', deal_url: '', website_url: '', image_url: '', terms: '',
  starts_at: '', expires_at: '', featured: false, status: 'draft',
};
